var map = {
	"./10bis-T-RGB-H.png": 19695,
	"./400_500_visual.svg": 68046,
	"./EmptyShoppingCartStat.svg": 67316,
	"./Header_Duddles.png": 46845,
	"./Header_Duddles_old.png": 40411,
	"./Logo.svg": 33096,
	"./ResponseModalImage.jpg": 15343,
	"./Vector.png": 44557,
	"./a11yMenuIcon.svg": 18543,
	"./accessibility-cover-desktop.jpg": 70611,
	"./accessibility-cover-mobile.jpg": 84061,
	"./ageRestrictionModalImg.svg": 55152,
	"./asap_and_pooled/asap.svg": 26086,
	"./asap_and_pooled/asap.webp": 67040,
	"./asap_and_pooled/pickup-je.svg": 21777,
	"./asap_and_pooled/pickup-je.webp": 90105,
	"./asap_and_pooled/pickup.svg": 58013,
	"./asap_and_pooled/pickup.webp": 55229,
	"./asap_and_pooled/pooled.svg": 12444,
	"./asap_and_pooled/pooled.webp": 4866,
	"./carouselInfo/celebration.svg": 97806,
	"./carouselInfo/celebration.webp": 96628,
	"./carouselInfo/group.svg": 16179,
	"./carouselInfo/group.webp": 52987,
	"./carouselInfo/minimum.svg": 53542,
	"./carouselInfo/minimum.webp": 80556,
	"./chains/chainspage_cover.png": 66796,
	"./chat.svg": 21123,
	"./chat_filled.svg": 51706,
	"./chat_outline.svg": 37148,
	"./cities/CityPageImage.jpg": 74411,
	"./cities/batYam.jpg": 3714,
	"./cities/bneiBrak.jpg": 99876,
	"./cities/givatayim.jpg": 49909,
	"./cities/haifa.jpg": 61305,
	"./cities/holon.jpg": 87922,
	"./cities/jerusalem.jpg": 2186,
	"./cities/netanya.jpg": 53650,
	"./cities/petachTikva.jpg": 87948,
	"./cities/ramatGan.jpg": 7457,
	"./cities/rehovot.jpg": 95323,
	"./cities/rishonLezion.jpg": 80294,
	"./cities/telAviv.jpg": 14919,
	"./city-img-batYam.jpg": 23702,
	"./city-img-bnaiBrak.jpg": 91132,
	"./city-img-givataym.jpg": 44990,
	"./city-img-holon.jpg": 29886,
	"./city-img-jerusalem.jpg": 70302,
	"./city-img-natanya.jpg": 52098,
	"./city-img-ramatGan.jpg": 13925,
	"./city-img-rehovot.jpg": 95999,
	"./city-img-telAviv.jpg": 53355,
	"./cityPageCover/Items.jpeg": 90251,
	"./cityPageCover/american.jpg": 70494,
	"./cityPageCover/asianFusion.jpg": 88546,
	"./cityPageCover/bar.jpg": 52737,
	"./cityPageCover/burgers.jpg": 3560,
	"./cityPageCover/chinese.jpg": 27839,
	"./cityPageCover/coffeeHouse.jpg": 33254,
	"./cityPageCover/confectionery.jpg": 30504,
	"./cityPageCover/convenienceStore.jpg": 35488,
	"./cityPageCover/default.jpg": 96125,
	"./cityPageCover/fish.jpg": 67098,
	"./cityPageCover/homeMade.jpg": 37866,
	"./cityPageCover/humus.jpg": 80164,
	"./cityPageCover/indian.jpg": 48405,
	"./cityPageCover/italian.jpg": 11074,
	"./cityPageCover/meatGrill.jpg": 17793,
	"./cityPageCover/mexican.jpg": 61181,
	"./cityPageCover/noCuisine.jpg": 58571,
	"./cityPageCover/pizza.jpg": 33404,
	"./cityPageCover/saladsAndSandwitches.jpg": 85672,
	"./cityPageCover/seafood.jpg": 66359,
	"./cityPageCover/sushi.jpg": 77964,
	"./colored.svg": 96789,
	"./contrastIcon.svg": 71244,
	"./delivery.svg": 73077,
	"./dialogs/closeDialogButton.svg": 2149,
	"./discount_flower.svg": 24666,
	"./discounts/discount-modal-je.jpg": 55930,
	"./discounts/discount-modal-je.webp": 38151,
	"./discounts/discount-modal.jpg": 50974,
	"./discounts/discount-modal.webp": 75947,
	"./errorTriangle.png": 78328,
	"./facebook.svg": 52065,
	"./fold.svg": 47892,
	"./goodbye-large.png": 98989,
	"./gov-orange-lg-logo.svg": 2464,
	"./green_smiley.png": 37753,
	"./hamburger.svg": 95066,
	"./header-background.png": 52546,
	"./header/basic-close.svg": 46050,
	"./header/x.svg": 49787,
	"./header_triangle_button.svg": 99300,
	"./homepage/advantage-badge.svg": 87809,
	"./homepage/advantages-benefits.svg": 82823,
	"./homepage/advantages-callcenter.png": 5077,
	"./homepage/advantages-control.png": 58875,
	"./homepage/advantages-delivery.png": 91286,
	"./homepage/advantages-delivery.svg": 59703,
	"./homepage/advantages-discount.png": 36763,
	"./homepage/advantages-navigate.svg": 36090,
	"./homepage/advantages-paypo-back.png": 48569,
	"./homepage/advantages-paypo.png": 31761,
	"./homepage/advantages-portals.png": 88645,
	"./homepage/advantages-quotation.png": 58254,
	"./homepage/advantages-system.png": 43673,
	"./homepage/advantages-time.svg": 68156,
	"./homepage/advantages-wallet.svg": 28388,
	"./homepage/app_promo.png": 65172,
	"./homepage/app_promo.webp": 28521,
	"./homepage/app_promo_en.png": 98156,
	"./homepage/app_promo_en.webp": 32129,
	"./homepage/background-burger.jpg": 72239,
	"./homepage/background-burger.webp": 26428,
	"./homepage/background-header-mobile-low-res.jpg": 41068,
	"./homepage/background-header-mobile.png": 68004,
	"./homepage/background-header.jpg": 89823,
	"./homepage/background-restaurant_owners.jpg": 80190,
	"./homepage/benefits-bill.png": 70031,
	"./homepage/benefits-card.svg": 67679,
	"./homepage/benefits-commission.png": 491,
	"./homepage/benefits-email.svg": 93707,
	"./homepage/benefits-registration.png": 3499,
	"./homepage/benefits-sales.png": 83942,
	"./homepage/benefits-shopping-cart.svg": 74480,
	"./homepage/benefits-signup.svg": 52881,
	"./homepage/bg-main-desktop.png": 31303,
	"./homepage/bg-main-mobile.png": 31953,
	"./homepage/companies-amdocs.png": 52384,
	"./homepage/companies-ebay.png": 91836,
	"./homepage/companies-keshet.png": 47717,
	"./homepage/companies-mobileye.png": 14403,
	"./homepage/credit-cards/a_tenbis.svg": 52141,
	"./homepage/credit-cards/b_diners-club.svg": 87275,
	"./homepage/credit-cards/c_american-express.svg": 63119,
	"./homepage/credit-cards/d_visa.svg": 83868,
	"./homepage/credit-cards/e_mastercard.svg": 524,
	"./homepage/facebook-login.png": 11285,
	"./homepage/geo.png": 59294,
	"./homepage/get-on-google-play.png": 25356,
	"./homepage/hamburger-big.png": 14565,
	"./homepage/hamburger-medium.png": 16530,
	"./homepage/hamburger-small.png": 37594,
	"./homepage/hamburger.png": 93720,
	"./homepage/hamburger.svg": 61789,
	"./homepage/ice-cream-big.png": 57060,
	"./homepage/ice-cream-small.png": 43067,
	"./homepage/just-eat/aside-from1004to1281.png": 1982,
	"./homepage/just-eat/aside-from1004to1281.webp": 41415,
	"./homepage/just-eat/aside-from1281.png": 25342,
	"./homepage/just-eat/aside-from1281.webp": 98887,
	"./homepage/just-eat/aside-from570to1004.png": 37152,
	"./homepage/just-eat/aside-from570to1004.webp": 89549,
	"./homepage/just-eat/aside-to570.png": 37653,
	"./homepage/just-eat/aside-to570.webp": 61382,
	"./homepage/landing_page_imgSM.png": 32816,
	"./homepage/logo-transparent.png": 41849,
	"./homepage/main-logo.svg": 43917,
	"./homepage/map.svg": 56666,
	"./homepage/pride-logo.svg": 93150,
	"./homepage/quote-ebay.png": 41095,
	"./homepage/quote-gigya.png": 48815,
	"./homepage/reasons-app.png": 41040,
	"./homepage/reasons-customers.png": 10946,
	"./homepage/reasons-marketing.png": 15753,
	"./homepage/reasons-menu.png": 98988,
	"./homepage/sushi-big.png": 81490,
	"./homepage/sushi-big.webp": 13443,
	"./homepage/sushi-medium.png": 31255,
	"./homepage/sushi-medium.webp": 91220,
	"./homepage/sushi-small.png": 25725,
	"./homepage/sushi-small.webp": 8750,
	"./homepage/ten-bis-card-background.jpg": 72977,
	"./homepage/ten-bis-card-background.webp": 56210,
	"./homepage/tenBis-gov-logo.svg": 70742,
	"./homepage/tenBis-logo.svg": 5959,
	"./homepage/user-login.png": 38792,
	"./ic_autorenew.png": 7389,
	"./icons/10bis.svg": 39499,
	"./icons/10bisPlusIcon.svg": 49708,
	"./icons/BackBT.svg": 61831,
	"./icons/DeliveryFeeGift.svg": 56186,
	"./icons/HomeMarker-old.svg": 62951,
	"./icons/HomeMarker.svg": 56671,
	"./icons/MapMarker.svg": 23500,
	"./icons/NoImgMobileMenu.svg": 36005,
	"./icons/RestaurantMarker-old.svg": 30759,
	"./icons/RestaurantMarker.svg": 40191,
	"./icons/active.svg": 84438,
	"./icons/address.svg": 72208,
	"./icons/alert-triangle-outlined.svg": 59374,
	"./icons/alert-triangle.svg": 28299,
	"./icons/appStore.svg": 61172,
	"./icons/arrow.svg": 67331,
	"./icons/arrow_down.svg": 95894,
	"./icons/arrow_down_white.svg": 33256,
	"./icons/arrow_left.svg": 35805,
	"./icons/arrow_left_carousel.svg": 3510,
	"./icons/asian.svg": 51584,
	"./icons/asian_active.svg": 74325,
	"./icons/asian_disabled.svg": 48679,
	"./icons/asian_mobile.svg": 7437,
	"./icons/avatar.svg": 36803,
	"./icons/bell.svg": 68291,
	"./icons/bicycle_active.svg": 17828,
	"./icons/big_green_check.svg": 3187,
	"./icons/burger-menu.svg": 8829,
	"./icons/cards/amex.svg": 7893,
	"./icons/cards/cardsList.png": 94972,
	"./icons/cards/cash.png": 29924,
	"./icons/cards/coloredamex.svg": 35791,
	"./icons/cards/creditCardIcon.png": 73143,
	"./icons/cards/creditcard.png": 86904,
	"./icons/cards/creditcard.svg": 49173,
	"./icons/cards/default.png": 79582,
	"./icons/cards/default.svg": 59855,
	"./icons/cards/defaultBlue.svg": 19063,
	"./icons/cards/defaultGray.png": 86143,
	"./icons/cards/defaultGray.svg": 1094,
	"./icons/cards/defaultWhite.svg": 10898,
	"./icons/cards/diners-club.svg": 48968,
	"./icons/cards/diners.png": 33126,
	"./icons/cards/discover.png": 43972,
	"./icons/cards/discover.svg": 26101,
	"./icons/cards/maestro.png": 65358,
	"./icons/cards/maestro.svg": 21039,
	"./icons/cards/mastercard.png": 89241,
	"./icons/cards/mastercard.svg": 53244,
	"./icons/cards/moneycard.png": 29779,
	"./icons/cards/moneycard.svg": 31582,
	"./icons/cards/newCreditCard.png": 73954,
	"./icons/cards/visa.png": 61230,
	"./icons/cards/visa_icon.svg": 45409,
	"./icons/cart.svg": 3866,
	"./icons/categories_button.svg": 48775,
	"./icons/category_type.svg": 85175,
	"./icons/check_circle.svg": 40883,
	"./icons/checked-icon.svg": 1399,
	"./icons/checked.svg": 67203,
	"./icons/checkmark-blue.svg": 31520,
	"./icons/checkmark_green.svg": 76671,
	"./icons/checkmark_outline.svg": 19708,
	"./icons/checkout.svg": 69548,
	"./icons/chevron-down-bold.svg": 60490,
	"./icons/chevron-down.svg": 54750,
	"./icons/chevron-right-small.svg": 63290,
	"./icons/chevron-right.svg": 49336,
	"./icons/chevronLeft.svg": 98006,
	"./icons/circle-info.svg": 69069,
	"./icons/clear_search.svg": 33090,
	"./icons/clear_search_old.svg": 72476,
	"./icons/clear_text.svg": 17903,
	"./icons/clock_alert.svg": 28781,
	"./icons/close-black.svg": 95758,
	"./icons/close-blue.svg": 3693,
	"./icons/close-circle-filled-2.svg": 79171,
	"./icons/close-circle-filled.svg": 64786,
	"./icons/close-darkBlue.svg": 44317,
	"./icons/close-icon-white-background.svg": 84235,
	"./icons/close-popup.svg": 1777,
	"./icons/close-red.svg": 64230,
	"./icons/close-white.svg": 91860,
	"./icons/closeMark.svg": 43143,
	"./icons/closeMobileModal.svg": 47949,
	"./icons/coins.svg": 9766,
	"./icons/confetti.svg": 14771,
	"./icons/coupon-blue.svg": 8551,
	"./icons/coupon-orange.svg": 70377,
	"./icons/cross.svg": 52312,
	"./icons/cuisine_type.svg": 44077,
	"./icons/cupon.svg": 95119,
	"./icons/currentLocation.svg": 49458,
	"./icons/cutlery.svg": 29850,
	"./icons/date.svg": 32324,
	"./icons/delete_icon.svg": 17383,
	"./icons/delivery.svg": 84120,
	"./icons/desktopSuccess.svg": 63017,
	"./icons/disabled.svg": 29944,
	"./icons/discount-coupon.svg": 14132,
	"./icons/discount.svg": 44873,
	"./icons/discount_active.svg": 33834,
	"./icons/discount_black.svg": 14061,
	"./icons/discount_disabled.svg": 75204,
	"./icons/discount_mobile.svg": 58002,
	"./icons/discount_orange.svg": 2898,
	"./icons/dish_type.svg": 65523,
	"./icons/drop_down_arrow.svg": 15288,
	"./icons/edit_blue.png": 4294,
	"./icons/edit_blue.svg": 21147,
	"./icons/error.svg": 58866,
	"./icons/facebook-blue.svg": 53565,
	"./icons/facebook-footer.svg": 88832,
	"./icons/facebook.svg": 11748,
	"./icons/failure-icon.svg": 35064,
	"./icons/failure.svg": 90718,
	"./icons/filter-discounts.svg": 38013,
	"./icons/filter-free-delivery-je.svg": 92000,
	"./icons/filter-free-delivery.svg": 19790,
	"./icons/filter-kosher.svg": 43481,
	"./icons/filter-new.svg": 95779,
	"./icons/filter-scoober-delivery.svg": 13151,
	"./icons/filter.svg": 91102,
	"./icons/filter_bicycle.svg": 19900,
	"./icons/filtered.svg": 9233,
	"./icons/filters.svg": 28001,
	"./icons/filters_new_large.svg": 36590,
	"./icons/gluten_free.svg": 62440,
	"./icons/gray-pooledUser.svg": 18630,
	"./icons/green_check.svg": 99612,
	"./icons/green_check_line.svg": 36001,
	"./icons/green_check_mark.svg": 74476,
	"./icons/grey_check_mark.svg": 38100,
	"./icons/groceries-default-image.svg": 69181,
	"./icons/hamburger.svg": 11125,
	"./icons/hamburger_active.svg": 74014,
	"./icons/hamburger_disabled.svg": 5360,
	"./icons/hamburger_mobile.svg": 28126,
	"./icons/home-address.svg": 26962,
	"./icons/homepage-arrow.svg": 51048,
	"./icons/ic_cart.svg": 65805,
	"./icons/ic_cart_minus.svg": 71240,
	"./icons/ic_cart_plus.svg": 72864,
	"./icons/ic_cart_x.svg": 2600,
	"./icons/ic_heart.svg": 38001,
	"./icons/ic_phone.svg": 53037,
	"./icons/infoIcon.svg": 54711,
	"./icons/instagram-footer.svg": 71536,
	"./icons/instagram.svg": 19508,
	"./icons/just-eat.svg": 59203,
	"./icons/kosher-en.svg": 27406,
	"./icons/kosher.svg": 8478,
	"./icons/location-icon.svg": 3145,
	"./icons/location.svg": 27045,
	"./icons/logo.svg": 33301,
	"./icons/logo_sq_colored.svg": 60075,
	"./icons/logo_sq_white.svg": 13738,
	"./icons/map.svg": 30178,
	"./icons/menu-dish-image-loading.svg": 6457,
	"./icons/menu-info-icon.svg": 93012,
	"./icons/menu-search.svg": 37818,
	"./icons/message.svg": 90165,
	"./icons/minusSignBig.svg": 36343,
	"./icons/minus_grey.svg": 26114,
	"./icons/mobile_back_blue.svg": 56951,
	"./icons/mobile_back_white.svg": 74034,
	"./icons/mobile_settings.svg": 97374,
	"./icons/new.svg": 22794,
	"./icons/pencil-blue.svg": 2404,
	"./icons/pencil-white.svg": 87567,
	"./icons/pie/chevronRight.svg": 27744,
	"./icons/pie/functionalityCloseSmall.svg": 85319,
	"./icons/pie/functionalityLogOut.svg": 3292,
	"./icons/pie/functionalityPlusSmall.svg": 639,
	"./icons/pie/functionalityTrashSmall.svg": 18909,
	"./icons/pie_israel.svg": 20237,
	"./icons/pie_us.svg": 45333,
	"./icons/pin_restaurant.svg": 87493,
	"./icons/pizza.svg": 2378,
	"./icons/pizza_active.svg": 29127,
	"./icons/pizza_disabled.svg": 69361,
	"./icons/pizza_mobile.svg": 37807,
	"./icons/playStore.svg": 49425,
	"./icons/plus_add_button.svg": 5383,
	"./icons/plus_grey.svg": 52170,
	"./icons/pluseSignBig.svg": 94412,
	"./icons/profileIcon.svg": 11360,
	"./icons/red_check_line.svg": 78877,
	"./icons/reorder-arrow-down.svg": 33274,
	"./icons/restaurant_tag.svg": 86488,
	"./icons/restaurant_type.svg": 91136,
	"./icons/scoober_tag.svg": 70970,
	"./icons/screen.svg": 22068,
	"./icons/search.svg": 89068,
	"./icons/search_empty_space.png": 90200,
	"./icons/shoppingBag.svg": 35542,
	"./icons/shopping_cart_dish_default.svg": 57746,
	"./icons/simple-arrow-right.svg": 45043,
	"./icons/spinner.svg": 69423,
	"./icons/star_popular_yellow.svg": 20509,
	"./icons/stores.svg": 51426,
	"./icons/success.svg": 20113,
	"./icons/sushi.svg": 60582,
	"./icons/sushi_active.svg": 80651,
	"./icons/sushi_disabled.svg": 44717,
	"./icons/sushi_mobile.svg": 76827,
	"./icons/ta-icon.svg": 96809,
	"./icons/table_report_menu_icon.svg": 30323,
	"./icons/target.svg": 38931,
	"./icons/tenbisCard.svg": 79943,
	"./icons/tenbisCredit.svg": 72942,
	"./icons/tenbis_square.svg": 55433,
	"./icons/three-dots.svg": 75769,
	"./icons/time-error.svg": 45782,
	"./icons/tooltip_info.svg": 60656,
	"./icons/user_plus.svg": 7812,
	"./icons/vegan.svg": 88187,
	"./icons/voucher-canceled-icon.svg": 23364,
	"./icons/white-left-arrow-hp.svg": 82224,
	"./icons/white-pooledUser.svg": 98748,
	"./icons/white_cart.svg": 53924,
	"./icons/white_edit.svg": 84886,
	"./icons/white_plus.svg": 58806,
	"./je-orange-lg-logo.svg": 57303,
	"./je-orange-sm-logo.svg": 23546,
	"./je_no_result_img.png": 40717,
	"./je_no_result_img.webp": 24414,
	"./je_no_result_img_mobile.png": 91480,
	"./je_no_result_img_mobile.webp": 54181,
	"./logo.png": 13653,
	"./menu-empty-search.svg": 2425,
	"./menu.png": 42661,
	"./missingItems.png": 21672,
	"./no-reorders.svg": 54617,
	"./orange-lg-logo.svg": 41905,
	"./orange-md-logo.svg": 38881,
	"./orange-sm-logo.svg": 92708,
	"./outlineIcon.svg": 44878,
	"./paypal.svg": 78584,
	"./pci-logo.png": 17928,
	"./pickup.svg": 86357,
	"./powered_by_google_on_white.png": 88932,
	"./pride-logo.svg": 61043,
	"./refreshTokenLogout-je.png": 15938,
	"./refreshTokenLogout.png": 55798,
	"./reorder-placeholder.png": 72503,
	"./reviewModalImg.png": 25192,
	"./scoober-logo-desktop-en.svg": 31937,
	"./scoober-logo-desktop-he.svg": 62741,
	"./scoober-logo-en.svg": 1240,
	"./scoober-logo-he.svg": 53320,
	"./scoober-logo-icon.svg": 35650,
	"./scrollTop.png": 34870,
	"./scrollTopOld.png": 99267,
	"./search.svg": 25765,
	"./searchNotFound.backup.png": 17149,
	"./settings.svg": 38982,
	"./shopping_cart_page_empty_state.svg": 30708,
	"./sms.jpg": 79061,
	"./star-half.svg": 77437,
	"./star-off.svg": 78541,
	"./star-on.svg": 84601,
	"./star-orange.svg": 26252,
	"./svgIconsAsText/back-arrow-new.svg": 46919,
	"./svgIconsAsText/back-arrow.svg": 274,
	"./svgIconsAsText/basic-arrow-down.svg": 45824,
	"./svgIconsAsText/clear_search.svg": 72589,
	"./svgIconsAsText/filter.svg": 49485,
	"./svgIconsAsText/filters.svg": 38148,
	"./svgIconsAsText/homepage-arrow.svg": 59987,
	"./svgIconsAsText/mobile_back.svg": 29977,
	"./svgIconsAsText/search-icon-mobile.svg": 78094,
	"./svgIconsAsText/search-icon.svg": 94751,
	"./svgIconsAsText/simple-arrow-right.svg": 39432,
	"./svgIconsAsText/three-dots.svg": 15258,
	"./svgIconsAsText/triangle.svg": 36663,
	"./tag.svg": 14039,
	"./tosit.svg": 67450,
	"./white-gov-logo.svg": 46761,
	"./white-logo.svg": 38520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93153;